/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_Ownership_ShareInputs */

const cs_parties_ownership_share = /** @type {(inputs: Parties_Ownership_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíl vlastnictví %`)
};

const en_parties_ownership_share = /** @type {(inputs: Parties_Ownership_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership share %`)
};

/**
* | output |
* | --- |
* | "Ownership share %" |
*
* @param {Parties_Ownership_ShareInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_ownership_share = /** @type {((inputs?: Parties_Ownership_ShareInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_Ownership_ShareInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_ownership_share(inputs)
	return cs_parties_ownership_share(inputs)
});